export function generatePagination(curPage, totalPages, pagesToShow): number[] {
  const spread = Math.floor(pagesToShow / 2);

  let pages = Array.from(
    { length: totalPages < pagesToShow ? totalPages : pagesToShow },
    (v, k) => k + (curPage - spread)
  );

  if (pages[0] < 1) {
    const difference = 1 + Math.abs(pages[0]);
    pages = pages.map((v) => v + difference);
  }

  if (pages[pages.length - 1] > totalPages) {
    const difference = pages[pages.length - 1] - totalPages;
    pages = pages.map((v) => v - difference);
  }

  return pages;
}
